<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h5>Podatki o blagajniku</h5>

        <div class="form-group">
          <label for="cachier.name.first">First name</label>
          <ValidationProvider name="first name" vid="cachier.name.first" v-slot="{ errors }" rules="required">
            <input class="form-control" v-model="cachier.name.first" :class="{ 'is-invalid': errors[0] }">
            <span class="text-danger">{{errors[0]}}</span>
          </ValidationProvider>
        </div>

        <div class="form-group">
          <label for="cachier.name.last">Last name</label>
          <ValidationProvider name="last name" vid="cachier.name.last" v-slot="{ errors }" rules="required">
            <input class="form-control" v-model="cachier.name.last" :class="{ 'is-invalid': errors[0] }">
            <span class="text-danger">{{errors[0]}}</span>
          </ValidationProvider>
        </div>

        <div class="form-group">
          <label for="cachier.taxNumber">Tax number</label>
          <ValidationProvider name="tax number" vid="cachier.taxNumber" v-slot="{ errors }" rules="required">
            <input class="form-control" v-model="cachier.taxNumber" :class="{ 'is-invalid': errors[0] }">
            <span class="text-danger">{{errors[0]}}</span>
          </ValidationProvider>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Cachier',
  data: () => ({
    'cachier': {
      'name': {
        'first': 'Janez',
        'last': 'Novak'
      },
      'taxNumber': 123456
    }
  }),
};
</script>
